import './Icon.css';
import { ReactNode } from 'react';
import { IconSize } from './iconTypes';

type Props = {
  children?: ReactNode;
  color?: string;
  className?: string;
  size?: IconSize;
  toolTip?: string;
};

const Icon = ({ color = '', className = '', size = IconSize.small, toolTip, children }: Props) => {
  return (
    <span
      className={`material-icons material-symbols-outlined ${className} ${size} ${color}`}
      title={toolTip}
      aria-hidden
    >
      {children}
    </span>
  );
};

export default Icon;
